module.exports = __webpack_public_path__ + "static/step-3@2x-25657e4364bbe892209bbda4a10cc293.png";